<template>
    <div class="result-article">
        <div class="result-article__wrapp">
            <div class="result-item result-item-rated">
                <div class="result-wrapp">
                    <div class="result__info">
                        <div class="result__logo">
                            <img v-if="offer.company.logo" :src="offer.company.logo" alt="logo">
                            <img v-else src="images/aboutUs-insurance_icon.svg" alt="logo">
                        </div>
                        <div class="result__info__main">
                            <div class="result__name">
                                <h5>{{ offer.companyNamePublic ? offer.companyNamePublic : offer.companyName }}</h5>
                                <span data-placement="bottom" data-toggle="tooltip" title="" class="mtsbu-icon" data-original-title="<div class=&quot;mtsbu-rating__heading&quot;><span>Рейтинг</span><img src=&quot;data:image/png;base64,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&quot; alt=&quot;МТСБУ&quot;><i data-placement=&quot;bottom&quot; data-toggle=&quot;tooltip&quot; title=&quot;&quot; class=&quot;icon question&quot; data-original-title=&quot;На основі квартального звіту МТСБУ по ОСЦПВ&quot;></i><p>На основі квартального звіту МТСБУ по ОСЦПВ</p></div><ul class=&quot;mtsbu-rating__list&quot;><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Загальна оцінка</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Качество урегулирования</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li><li class=&quot;mtsbu-rating__item&quot;><span class=&quot;mtsbu-rating__name&quot;>Уровень жалоб</span><!----><!----><span class=&quot;mtsbu-rating__value rating-good&quot;><span>Добре</span></span></li></ul><div class=&quot;mtsbu-rating__deadlines&quot;><span>0 днів</span><p>швидкість виплати по ОСЦПВ</p></div>">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="8" cy="8" r="8" fill="#EF4137"></circle>
                                  <path d="M4.75736 11.4853L11.1213 5.12132M11.1213 5.12132H6.87868M11.1213 5.12132L11.2427 9.24256" stroke="white" stroke-width="1.5"></path>
                                </svg>
                              </span>
                            </div>
                            <div class="result__rating">
                                <i v-for="stars in 5" :key="stars">
                                    <svg v-if="Math.floor(offer.company.rating) >= stars" width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.99984 13.417L14.1665 16.5003L12.8332 10.667L17.3332 6.66699L11.3332 6.16699L8.99984 0.666992L6.6665 6.16699L0.666504 6.66699L5.24984 10.667L3.9165 16.5003L8.99984 13.417Z" fill="#FA9B13"></path>
                                    </svg>
                                    <svg v-else width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.25607 12.9876L8.99774 12.8335L8.74053 12.9895L4.66713 15.4602L5.73727 10.7784L5.8039 10.4869L5.5786 10.2903L1.88543 7.06715L6.70803 6.66527L7.00889 6.64019L7.12679 6.36227L8.99984 1.94724L10.8729 6.36227L10.9908 6.64019L11.2916 6.66527L16.129 7.06838L12.501 10.2933L12.2798 10.4899L12.3457 10.7784L13.4185 15.4717L9.25607 12.9876Z" stroke="#FA9B13"></path>
                                    </svg>
                                </i>
                            </div>
                            <div class="result__department">
                                <a href="javascript:void(0)">
                                    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.84798 6.84758C8.84798 7.55482 8.56703 8.2331 8.06693 8.73319C7.56684 9.23329 6.88856 9.51424 6.18131 9.51424C5.47407 9.51424 4.79579 9.23329 4.2957 8.73319C3.7956 8.2331 3.51465 7.55482 3.51465 6.84758C3.51465 6.14033 3.7956 5.46205 4.2957 4.96196C4.79579 4.46186 5.47407 4.18091 6.18131 4.18091C6.88856 4.18091 7.56684 4.46186 8.06693 4.96196C8.56703 5.46205 8.84798 6.14033 8.84798 6.84758ZM7.51465 6.84758C7.51465 7.2012 7.37417 7.54034 7.12412 7.79038C6.87408 8.04043 6.53494 8.18091 6.18131 8.18091C5.82769 8.18091 5.48855 8.04043 5.23851 7.79038C4.98846 7.54034 4.84798 7.2012 4.84798 6.84758C4.84798 6.49395 4.98846 6.15481 5.23851 5.90477C5.48855 5.65472 5.82769 5.51424 6.18131 5.51424C6.53494 5.51424 6.87408 5.65472 7.12412 5.90477C7.37417 6.15481 7.51465 6.49395 7.51465 6.84758Z" fill="#009BEB"></path>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.86267 11.0119C1.00323 10.1936 0.405739 9.13884 0.14576 7.98098C-0.11422 6.82312 -0.0250142 5.61416 0.402097 4.507C0.829208 3.39983 1.57504 2.44419 2.54528 1.76091C3.51552 1.07762 4.66659 0.697397 5.85292 0.668308C7.03926 0.639218 8.20758 0.962572 9.21014 1.59748C10.2127 2.23239 11.0045 3.15033 11.4853 4.23523C11.9662 5.32013 12.1146 6.52326 11.9116 7.69248C11.7087 8.86169 11.1636 9.94447 10.3453 10.8039L6.208 15.1492L1.86267 11.0119ZM9.38 9.88457L6.162 13.2646L2.782 10.0466C2.11358 9.41012 1.64889 8.58976 1.4467 7.68922C1.24451 6.78868 1.31389 5.8484 1.64608 4.9873C1.97827 4.12619 2.55833 3.38292 3.31294 2.85148C4.06754 2.32004 4.96278 2.02429 5.88547 2.00163C6.80815 1.97898 7.71683 2.23043 8.4966 2.7242C9.27637 3.21797 9.89222 3.93188 10.2663 4.77564C10.6403 5.61941 10.7558 6.55515 10.598 7.46453C10.4403 8.37391 10.0164 9.21608 9.38 9.88457Z" fill="#009BEB"></path>
                                    </svg>
                                    <span>10 відділень</span>
                                </a>
                            </div>

                            <div class="result__proposition_icon nomobile">
                                <div class="proposition-icon-box" v-if="!offer.company.discountPrice && !isApiUser" @click="discountSet($event, offer.company)">
                                    <svg width="18" height="18" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect width="100" height="100" fill="url(#pattern0_927_2)"/>
                                        <defs>
                                            <pattern id="pattern0_927_2" patternContentUnits="objectBoundingBox" width="1" height="1">
                                                <use xlink:href="#image0_927_2" transform="scale(0.01)"/>
                                            </pattern>
                                            <image id="image0_927_2" width="100" height="100" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
                                        </defs>
                                    </svg>
                                    <modal-discount-set :id="offer.company.offerId" :offer="offer.company"  @update:offer="handleUpdateOffer"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="result__details">
                        <div class="result__options__wrapp">
                            <div class="result__heading" >{{ getHomeType }}</div>
                            <div class="result__content_wrapper">
                                <div class="result__params">
                                    <div class="result__param">
                                        <div class="result__param__name">{{ getInsuranceAmount }}</div>
                                        <div class="result__param__value">Страховий ліміт</div>
                                    </div>
                                    <div class="result__param">
                                        <div class="result__param__name">{{ getInsurancePeriod }}</div>
                                        <div class="result__param__value">Період дії договору</div>
                                    </div>
                                </div>
                            </div>
                            <div class="result__additional">
                                <div class="result__message">
                                    Покриває воєнні ризики: захист від падіння ракет та "шахедів"
                                </div>
                            </div>
                        </div>
                        <div class="result__more"><a data-toggle="collapse" :data-target="'#brandMore-'+offer.id" aria-expanded="false" :aria-controls="'brandMore-'+offer.id" class="collapsed"> Детальніше про поліс <img src="/img/arrow-down.8bfc342c.svg" alt="Детальніше про поліс"></a></div>
                    </div>
                    <div class="result__order">
                        <div v-if="showEarnings && offer.earnings">
                            <div class="result__earnings" v-if="offer.fullPrice">
                                Нетто платіж {{ offer.fullPrice - offer.earnings}} грн
                            </div>
                            <div class="result__earnings" v-else>
                                Нетто платіж {{ offer.price - offer.earnings}} грн
                            </div>
                        </div>
                        <div class="result__price">
                            <div class="value" v-if="offer.fullPrice"> {{ offer.fullPrice}} <span>грн</span></div>
                            <div class="value" v-else> {{ offer.price }} <span>грн</span></div>
                        </div>
                        <button class="result__submit" v-loading="loading" @click="concludeContract()"> Оформити </button>
                        <div v-if="showEarnings && offer.earnings">
                            <div class="result__earnings">
                                Ваш заробіток {{offer.earnings}} грн
                            </div>
                            <div class="result__earnings" v-if="offer.fullPrice">
                                ({{ Math.round(offer.earnings / offer.fullPrice * 100) }}%)
                            </div>
                            <div class="result__earnings" v-if="!offer.fullPrice">
                                ({{ Math.round(offer.earnings / offer.price * 100) }}%)
                            </div>
                        </div>
                    </div>
                    <div class="result__nav mob"><a data-toggle="collapse" :data-target="'#brandMore-'+offer.id" aria-expanded="false" :aria-controls="'brandMore-'+offer.id" class="more collapsed"> Детальніше <img src="/img/arrow-down.8bfc342c.svg" alt="Детальніше"></a></div>
                </div>
                <div :id="'brandMore-'+offer.id" class="row details collapse details-article-more">
                    <div class="col-12">
                        <div class="details__wrapp">
                            <div class="details__heading">Загальна інформація</div>
                            <div class="details__links_wrapper">
                                <a class="details__link" :href="offer.company.docProduct">Інформація про страховий продукт</a>
                                <a class="details__link" :href="offer.company.docAgent">Інформація про страхового посередника</a>
                                <a class="details__link" :href="offer.company.docCompany">Інформація про страховика</a>
                                <a class="details__link" :href="offer.company.docZusp">Інформація про загальні умови страхового продукту</a>
                            </div>
                            <ProductDescription class="mb-3" :description="offer.company.description" />
                            <div class="details__content_wrapper">
                                <div class="details__list">
                                    <div class="details__list__subheading">Захист від:</div>
                                    <ul>
                                        <li>✅ Воєнних ризиків;</li>
                                        <li>✅ Битого скла (включаючи наслідки воєнних ризиків);</li>
                                        <li>✅ Побутових ризиків;</li>
                                        <li>✅ Стихійних лих;</li>
                                        <li>✅ Протиправних дій;</li>
                                        <li>✅ Відповідальності перед третіми особами.</li>
                                    </ul>
                                </div>
                                <div class="details__list">
                                    <ul>
                                        <li>📌 <strong>Франшиза:</strong> 1000 грн</li>
                                        <li>⏳ <strong>Дія полісу</strong> починається на 11-й день після підписання.</li>
                                        <li>🛑 <strong>Не страхується:</strong> готівка, документи, картини, коштовності, зброя, книги, іграшки.</li>
                                    </ul>
                                </div>
                                <div class="details__list">
                                    <ul>
                                        <li>🛑 <strong>Території виключення:</strong> АР Крим; Дніпропетровська область; Донецька область;
                                            Запорізька область; Луганська область; Миколаївська область; Сумська область; Харківська область;
                                            Херсонська область; Чернігівська область/Корюківський район; Чернігівська область/Новгород-Сіверський район;
                                            Чернігівська область/Чернігівський район крім м.Чернігів.
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { orderHome } from '@/api/orderHome';
import ModalDiscountSet from "@/components/app/modals/modal-discount-set.vue";
import { ProductDescription } from '@/shared/ui/insurance';

export default {
    components: {ModalDiscountSet, ProductDescription},
    props: ['offer', 'showEarnings', 'payer', 'houseInfo'],

    data() {
        return {
            loading: false,
            homeTypes: [],
            insuranceAmounts: [],
            insurancePeriods: [],
        };
    },

    created() {
        this.homeTypes = this.$store.getters.HOME_TYPES;
        this.insuranceAmounts = this.$store.getters.HOME_AMOUNTS;
        this.insurancePeriods = this.$store.getters.HOME_PERIODS;

        console.log('offer', this.offer);
    },

    computed: {
        user() {
            return this.$store.getters.USER;
        },
        isApiUser() {
            return this.user && Number(this.user.type_id) === 5;
        },
        getHomeType() {
            return this.$_.findWhere(this.homeTypes, { id: this.offer.home_type })?.name;
        },

        getInsuranceAmount() {
            return this.$_.findWhere(this.insuranceAmounts, { id: this.offer.insurance_amount })?.name;
        },

        getInsurancePeriod() {
            return this.$_.findWhere(this.insurancePeriods, { id: this.offer.insurance_period })?.name;
        },
    },

    methods: {
        discountSet(event, offer){
            //this.$set(offer, "showModal", !offer.showModal);
        },

        handleUpdateOffer(updatedOffer) {
            this.companies.forEach((offer) => {
                offer.showModal = false
                if (offer.offerId === updatedOffer.offerId) {
                    if(parseFloat(updatedOffer.price) > parseFloat(updatedOffer.discountPrice)){
                        this.$set(offer, "dynamicDiscountPrice", +parseFloat(updatedOffer.discountPrice).toFixed(2));
                        this.$set(offer, "dynamicDiscountPercent", +parseFloat(updatedOffer.discountPercent).toFixed(2));
                        this.$set(offer, "dynamicDiscountedSum", +parseFloat(updatedOffer.discountedSum).toFixed(2));
                        this.$set(offer, "dynamicEarnings", +parseFloat(updatedOffer.earnings).toFixed(2));
                    }else if (parseFloat(updatedOffer.discountPrice) >= 0){
                        this.$set(offer, "dynamicDiscountPrice", 0);
                        this.$set(offer, "dynamicDiscountPercent", 0);
                        this.$set(offer, "dynamicDiscountedSum", 0);
                        this.$set(offer, "dynamicEarnings", 0);
                    }
                }
            });
        },

        concludeContract() {
            this.loading = true;
            this.offer.allowed_documents = this.offer.available_documents ?? this.offer.allowed_documents ?? null;
            const searchInfo = {
                homeType: this.$store.getters.HOME_SEARCH_PARAMS.homeType.param,
                insuranceAmount: this.$store.getters.HOME_SEARCH_PARAMS.insuranceAmount.param,
                insurancePeriod: this.$store.getters.HOME_SEARCH_PARAMS.insurancePeriod.param,
                earnings: this.$store.getters.HOME_SEARCH_PARAMS.earning.value,
                startDate: this.formatDate(this.$store.getters.HOME_SEARCH_PARAMS.startDate),
            };

            const params = { type: 'next', statusId: -1 };

            if (!this.isFromHistory()) {
                this.$store.commit('SET_HOME_INFO_USER', this.payer);
                this.$store.commit('SET_HOME_INFO_HOUSE', this.houseInfo);
            }

            orderHome(this.offer, searchInfo, this.payer, this.houseInfo, null, params)
                .then((response) => {
                    this.loading = false;

                    this.$store.commit('SET_HOME_FULL_ORDER', response?.data?.data[0]?.id);
                    this.$store.commit('SET_HOME_INFO_OFFER', this.offer);

                    this.$router.push({name: `homeSteps`});
                })
                .catch((error) => {
                    this.$alert('Щось пішло не так. Перевірте заповнені поля.');
                });
        },

        isFromHistory() {
            return this.$route.query.from === 'history';
        },

        formatDate(date) {
            if (date.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
                date = date.replace(/\./g, '-');
            }

            return date;
        },
    },
}
</script>
<style scoped>
    .result__heading {
        font-size: 32px;
        font-weight: 500;
        padding: 15px 20px;
    }

    .result__content_wrapper {
        padding: 0 0 0 20px;
    }

    .result__param__name {
        font-size: 32px;
        font-weight: 400;
        line-height: 30px;
    }

    .result__param__value {
        font-size: 13px;
        font-weight: 400;
        color: #999DA6;
    }

    .result__additional {
        display: flex;
        align-items: center;
    }

    .result__message {
        display: inline-block;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        color: #FFF;
        background-color: #FA9B13;
        border-radius: 10px;
        padding: 7px 15px 4px;
        margin: 25px auto 20px auto;
    }

    .details__content_wrapper {
        display: flex;
    }

    .details__links_wrapper {
        display: grid;
        gap: 12px;
        margin-bottom: 15px;
    }

    @media (max-width: 767px) {
        .details__links_wrapper {
            grid-template-columns: 1fr;
        }
    }
    @media (min-width: 768px) and (max-width: 1023px) {
        .details__links_wrapper {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (min-width: 1024px) {
        .details__links_wrapper {
            grid-template-columns: repeat(4, 1fr);
        }
    }

    .details__link {
        display: block;
        font-size: 15px;
        font-weight: 700;
        text-decoration: underline;
        color: #0079B8;
        text-align: center;
        padding: 8px;
    }

    .details__list__heading {
        font-size: 15px;
        font-weight: 700;
        text-decoration: underline;
        color: #0079B8;
        padding-bottom: 32px;
    }

    .details__list__subheading {
        font-size: 16px;
        font-weight: 700;
    }

    .details__list li {
        font-size: 13px;
        font-weight: 400;
    }

    @media (max-width: 1199px) {
        .result__content_wrapper {
            padding: 0 0 0 20px;
        }

        .result__heading {
            font-size: 26px;
        }

        .result__param__name {
            font-size: 26px;
        }

        .result__message {
            font-size: 12px;
        }
    }

    @media (max-width: 768px) {
        .result__content_wrapper {
            padding: 0;
        }

        .result__param__name {
            padding-right: 15px;
        }

        .details__content_wrapper {
            display: block;
        }

        .details__list {
            padding-top: 10px;
        }
    }
</style>
